import {
	Users,
	LineChart,
	Brain,
	Rocket,
	FileSpreadsheet,
	LayoutTemplate,
	Puzzle,
	ClipboardList,
	GitBranch,
	Calendar,
	Calculator,
	Code,
	TestTube,
	BookOpen,
	LifeBuoy,
	BarChart,
	UserCog,
	Database,
	Wrench,
} from 'lucide-react';

export const process = [
	{
		title: 'Getting Started',
		description:
			"We've got simple tools to help you take the first step — whether you'd rather talk it through, see some pricing options, or start from a pre-built project example, we'll meet you where you are.",
		icon: Rocket,
		modalDetails: [
			{
				title: 'Schedule a Discovery Session',
				description:
					"Prefer to talk it through? Book a 1:1 consult and I'll help map out what makes sense for your business.",
				icon: Brain,
			},
			{
				title: 'Use the Project Calculator',
				description:
					'Scope out what you need from each pillar — Power Apps, dashboards, automations, and more.',
				icon: Calculator,
				link: {
					text: 'Try our Project Calculator',
					href: '/calculator',
				},
			},
			{
				title: 'Start From a Template',
				description:
					'Select a pre-built example to populate the calculator with a common project setup — and tweak from there.',
				icon: LayoutTemplate,
				link: {
					text: 'View Templates',
					href: '/calculator?defaultTab=templates',
				},
			},
			{
				title: 'Flexible by Design',
				description:
					"Already started something? We'll focus on the pieces you're missing, not force you into a rigid package.",
				icon: Puzzle,
			},
		],
	},
	{
		title: 'Co-Design Your Tech Blueprint',
		description:
			"We'll map the workflows, tools, and data flows you need across the Four Pillars to create a tailored, scalable system.",
		icon: ClipboardList,
		modalDetails: [
			{
				title: 'Collaborative Planning',
				description:
					"Together, we'll define your must-haves, nice-to-haves, and the gaps in your current systems.",
				icon: Users,
			},
			{
				title: 'Workflow & Tech Mapping',
				description:
					'Map out how your internal tools, data, and automations should connect across the Four Pillars.',
				icon: GitBranch,
			},
			{
				title: 'Timeline & Milestones',
				description: 'Set realistic delivery phases and checkpoints to keep the build on track.',
				icon: Calendar,
			},
			{
				title: 'Clear Scope & Estimate',
				description:
					"You'll receive a clean, no-fluff proposal that reflects the actual tools and effort required.",
				icon: FileSpreadsheet,
			},
		],
	},
	{
		title: 'Build the Right Tools, Not Just More Tech',
		description:
			"I'll personally develop your apps, automations, and dashboards — designed to solve real business problems, not just add more software.",
		icon: Code,
		modalDetails: [
			{
				title: 'Custom Development',
				description:
					'Power Apps, dashboards, workflows, SQL databases, and integrations — built to spec, not out-of-the-box.',
				icon: Database,
			},
			{
				title: 'Testing & Review Cycles',
				description:
					"I test everything before handoff — and we iterate together to ensure it's truly useful.",
				icon: TestTube,
			},
			{
				title: 'Training & Documentation',
				description:
					"You'll receive how-to docs, recordings, or live walkthroughs based on what your team needs.",
				icon: BookOpen,
			},
			{
				title: 'Launch & Support Options',
				description:
					'Deploy with confidence — and choose if you want post-launch support, analytics, or vCIO services.',
				icon: LifeBuoy,
			},
		],
	},
	{
		title: 'Partner for Growth',
		description:
			"With ongoing support, strategy, and reporting, I'll stay in your corner as your tech evolves alongside your business.",
		icon: UserCog,
		modalDetails: [
			{
				title: 'Monthly Strategy Check-Ins',
				description:
					'Plan your next steps, review roadmaps, and realign tech to your evolving goals.',
				icon: BarChart,
			},
			{
				title: ' Dashboards & Reporting Support',
				description: 'Get help with recurring reports, insights, and keeping your data useful.',
				icon: LineChart,
			},
			{
				title: 'vCIO & Analyst Retainers',
				description:
					'Need a fractional tech lead or ongoing data analyst? I offer flexible plans to support your growth.',
				icon: UserCog,
			},
			{
				title: 'Mini Builds & Updates',
				description: 'Add a new form, tweak a dashboard, or request a small automation anytime.',
				icon: Wrench,
			},
		],
	},
];
